module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_3.040ed59ffda0ba534d80889277ae6da9.png";